import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { profileReducerKey } from './ProfileConstants';
import { trackAdobeAnalyticsError, init, setInputData, resetInputData, saveInputData } from './ProfileActions';
import {
  isLoading as isLoadingSelector,
  inputData as inputDataSelector,
  allSalutations as allSalutationsSelector,
} from './ProfileSelectors';
import ProfileReducer from './ProfileReducer';
import Profile from './Profile';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  inputData: inputDataSelector(state),
  allSalutations: allSalutationsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(init()),
  changeInputData: (data) => dispatch(setInputData(data)),
  resetInputData: (fieldName) => dispatch(resetInputData(fieldName)),
  saveInputData: (fieldName) => dispatch(saveInputData(fieldName)),
  trackAdobeAnalyticsError: (fieldName, formErrors) => trackAdobeAnalyticsError(fieldName, formErrors),
});

export default compose(withReducer(profileReducerKey, ProfileReducer), connect(mapStateToProps, mapDispatchToProps))(Profile);
